import { combineReducers } from "redux";
import player from "./player";

export default combineReducers({ player });
